import { render, staticRenderFns } from "./ColdLake.vue?vue&type=template&id=e60f1574"
import script from "./ColdLake.vue?vue&type=script&lang=js"
export * from "./ColdLake.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports